// To be deleted once all calculators are done with currency tier-1 adoptions
// Dependencies

import React from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';

import { Type } from '@nerdwallet/currency';

import ImageSizes from '../../config/images/imageSizes';

// CSS
require('./full-width-panel.less');

const FullWidthPanel = ({ header, iconUrl, className, children, id }) => {
  let iconJsx;
  let headerJsx;

  if (iconUrl) {
    iconJsx = (
      <div className="full-width-panel-bubble">
        <img
          className="full-width-panel-img"
          {...ImageSizes.largeIcon.measures}
          src={iconUrl}
          alt=""
        />
      </div>
    );
  }

  if (header) {
    headerJsx = (
      <Type component="h2" className="full-width-panel-header">
        {header}
      </Type>
    );
  }

  return (
    <div className={classnames('full-width-panel', className)} id={id}>
      <div className="full-width-panel-wrap">
        {iconJsx}
        {headerJsx}
        {children}
      </div>
    </div>
  );
};

FullWidthPanel.displayName = 'FullWidthPanel';

FullWidthPanel.propTypes = {
  header: PropTypes.string,
  iconUrl: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  id: PropTypes.string,
};

FullWidthPanel.defaultProps = {
  id: null,
  header: null,
  iconUrl: null,
  className: null,
  children: null,
};

export default FullWidthPanel;
